import type { CreateDeviceDto, DeviceDto, GetDeviceListDto, UpdateDeviceDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DevicesService {
  apiName = 'Default';
  

  create = (input: CreateDeviceDto) =>
    this.restService.request<any, DeviceDto>({
      method: 'POST',
      url: '/api/app/devices',
      body: input,
    },
    { apiName: this.apiName });
  

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/devices/${id}`,
    },
    { apiName: this.apiName });
  

  get = (id: string) =>
    this.restService.request<any, DeviceDto>({
      method: 'GET',
      url: `/api/app/devices/${id}`,
    },
    { apiName: this.apiName });
  

  getList = (input: GetDeviceListDto) =>
    this.restService.request<any, PagedResultDto<DeviceDto>>({
      method: 'GET',
      url: '/api/app/devices',
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  update = (id: string, input: UpdateDeviceDto) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/devices/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
